import { safeParse, safeParseNullDefault } from 'shouldve-been-js';

class ObservationSubChapter {

    private _subChapterId: string;
    private _ruleSetId: string;
    private _chapterId: string;
    private _itemNo: string;
    private _name: string;
    private _description: string;
    private _sortNumber: number;
    private _status: string;

    public constructor(subChapterId: string, ruleSetId: string, chapterId: string, itemNo: string, name: string, description: string, sortNumber: number, status: string) {

        this._subChapterId = subChapterId;
        this._ruleSetId = ruleSetId;
        this._chapterId = chapterId;
        this._itemNo = itemNo;
        this._name = name;
        this._description = description;
        this._sortNumber = sortNumber;
        this._status = status;
    }

    public get subChapterId(): string {
        return this._subChapterId;
    }

    public set subChapterId(value: string) {
        this._subChapterId = value;
    }

    public get ruleSetId(): string {
        return this._ruleSetId;
    }

    public set ruleSetId(value: string) {
        this._ruleSetId = value;
    }

    public get chapterId(): string {
        return this._chapterId;
    }

    public set chapterId(value: string) {
        this._chapterId = value;
    }

    public get itemNo(): string {
        return this._itemNo;
    }

    public set itemNo(value: string) {
        this._itemNo = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get description(): string {
        return this._description;
    }

    public set description(value: string) {
        this._description = value;
    }

    public get sortNumber(): number {
        return this._sortNumber;
    }

    public set sortNumber(value: number) {
        this._sortNumber = value;
    }

    public get status(): string {
        return this._status;
    }

    public set status(value: string) {
        this._status = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): ObservationSubChapter | null {

        const subChapterId: string | null = safeParseNullDefault<string>(json?.subChapterId, '');
        const rulesetId: string | null = safeParseNullDefault<string>(json?.ruleSetId, '');
        const chapterId: string | null = safeParseNullDefault<string>(json?.chapterId, '');
        const itemNo: string = safeParse<string>(json?.itemNo, '');
        const name: string = safeParse<string>(json?.name, '');
        const description: string = safeParse<string>(json?.description, '');
        const sortNumber: number = safeParse<number>(json?.sortNumber, 0);
        const status: string | null = safeParseNullDefault<string>(json?.status, '');
        
        if (subChapterId === null || rulesetId === null || chapterId === null || status === null || subChapterId === '' || rulesetId === '' || chapterId === '') {
            return null;
        }

        return new ObservationSubChapter(subChapterId, rulesetId, chapterId, itemNo, name, description, sortNumber, status);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): ObservationSubChapter | null {

        const subChapterId: string | null = safeParseNullDefault<string>(object?._subChapterId, '');
        const rulesetId: string | null = safeParseNullDefault<string>(object?._ruleSetId, '');
        const chapterId: string | null = safeParseNullDefault<string>(object?._chapterId, '');
        const itemNo: string = safeParse<string>(object?._itemNo, '');
        const name: string = safeParse<string>(object?._name, '');
        const description: string = safeParse<string>(object?._description, '');
        const sortNumber: number = safeParse<number>(object?._sortNumber, 0);
        const status: string | null = safeParseNullDefault<string>(object?._status, '');
        
        if (subChapterId === null || rulesetId === null || chapterId === null || status === null || subChapterId === '' || rulesetId === '' || chapterId === '') {
            return null;
        }

        return new ObservationSubChapter(subChapterId, rulesetId, chapterId, itemNo, name, description, sortNumber, status);
    }
}

export default ObservationSubChapter;